import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: 'home' */ "@/views/home"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/appShare",
    name: "appShare",
    component: () =>
      import(/* webpackChunkName: 'appShare' */ "@/views/appShare"),
    meta: {
      title: "APP分享"
    }
  },
  {
    path: "/publishShare",
    name: "publishShare",
    component: () =>
      import(/* webpackChunkName: 'publishShare' */ "@/views/publishShare"),
    meta: {
      title: "发布分享"
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: 'PrivacyPolicy' */ "@/views/protocol/PrivacyPolicy.vue"
      ),
    meta: {
      title: "波萝隐私政策"
    }
  },
  {
    path: "/membership-service-agreement",
    name: "MembershipServiceAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'MembershipServiceAgreement' */ "@/views/protocol/MembershipServiceAgreement.vue"
      ),
    meta: {
      title: "波萝会员服务协议"
    }
  },
  {
    path: "/automatic-renewal",
    name: "AutomaticRenewal",
    component: () =>
      import(
        /* webpackChunkName: 'MembershipServiceAgreement' */ "@/views/protocol/AutomaticRenewal.vue"
      ),
    meta: {
      title: "波萝会员自动续费服务协议"
    }
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'userAgreement' */ "@/views/protocol/user-aggreement.vue"
      ),
    meta: {
      title: "用户协议"
    }
  },
  {
    path: "/activity",
    name: "Activity",
    component: () =>
      import(
        /* webpackChunkName: 'Activity' */ "@/views/activitys/Activity.vue"
      ),
    meta: {
      title: "福利中心"
    }
  },
  {
    path: "/health-privacy-policy",
    name: "HealthPrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: 'HealthPrivacyPolicy' */ "../views/protocol/health-privacy-policy.vue"
      ),
    meta: {
      title: "波萝健康隐私政策"
    }
  },
  {
    path: "/health-user-agreement",
    name: "HealthUserAgreement",
    component: () =>
      import(
        /* webpackChunkName: 'HealthUserAgreement' */ "../views/protocol/health-user-agreement.vue"
      ),
    meta: {
      title: "波萝健康用户服务协议"
    }
  },
  {
    path: "/third-party-information-sharing-list",
    name: "ThirdPartyInformationSharingList",
    component: () =>
      import(
        /* webpackChunkName: 'ThirdPartyInformationSharingList' */ "../views/protocol/ThirdPartyInformationSharingList.vue"
      ),
    meta: {
      title: "波萝健康第三方信息共享列表"
    }
  },
  {
    path: "/personal-information",
    name: "PersonalInformation",
    component: () =>
      import(
        /* webpackChunkName: 'PersonalInformation' */ "../views/protocol/PersonalInformation.vue"
      ),
    meta: {
      title: "波萝健康个人信息"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

export default router;
